
























































import Vue from "vue";

import { Dashboard } from "@/model/data/dashboard/Dashboard";
import { DeleteDashboardCommand } from "@/model/communication/dashboard/dashboard/DeleteDashboardCommand";
import { CreateDashboardCommand } from "@/model/communication/dashboard/dashboard/CreateDashboardCommand";
import { UpdateDashboardCommand } from "@/model/communication/dashboard/dashboard/UpdateDashboardCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";

export default Vue.extend({
    data() {
        return {
            loading: false,
            errorMessage: "",
            availableIcons: [
                "exclamation-triangle",
                "flag",
                "exclamation",
                "ban",
                "euro-sign",
                "coins",
                "money-bill-wave",
                "dollar-sign",
                "check-circle",
                "money-bill",
                "flag-checkered",
                "list-ul",
                "bell",
            ],
        };
    },
    props: {
        dashboard: Dashboard,
        isNew: Boolean,
    },
    methods: {
        async onDeleteClick() {
            this.loading = true;

            const res = await new DeleteDashboardCommand((this.dashboard as Dashboard).id).execute();

            this.loading = false;
            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                this.$emit("fetch");
                this.$emit("close");
            } else {
                console.error(res);
                this.errorMessage = res.responseStatus;
            }
        },
        onCancelClick() {
            this.$emit("close");
        },
        async onSaveClick() {
            this.loading = true;

            let command;
            if (this.isNew) {
                command = new CreateDashboardCommand(this.dashboard);
            } else {
                command = new UpdateDashboardCommand(this.dashboard);
            }

            const res: ApiGenericResponse = await command.execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                this.$emit("fetch");
                this.$emit("close");
            } else {
                this.errorMessage = res.errorMessage;
            }

            this.loading = false;
        },
    },
});
